import { cardFuncEnumToViz } from "../../card-data/card-data-viz";


export default class TargetCardElement {
  constructor(cardIntVal, parentEl) {
    this.domEl = document.createElement('div');
    this.domEl.classList.add('target-seq-card');

    this.domEl.textContent = cardIntVal;
    // perhaps optional cardFunc at some point...
/*
    if (requireFunc) {
      this.cardFuncViz = cardFuncEnumToViz[cardData.cardFuncContainer.cardFuncEnum];

      this.domEl.textContent = `${cardData.intVal} ${this.cardFuncViz.debugFuncStr}`;

    }
    else {
      this.domEl.textContent = cardData.intVal;
    }
    */

    parentEl.appendChild(this.domEl);

  }

  dispose() {
    this.domEl.remove();
  }
}